/**
 * システムコード選択共通
 */
<script>
	export default {
		computed: {
			list_systemcode: function(){
				return this.$store.getters.systemcode_get_list;
			},
		},
		methods: {
			// リスト for selectItem
			getSystemcodeList: function(key){
				if(this.list_systemcode[key]){
					return $.extend(true, [], this.list_systemcode[key]['list']);
				}
				return [];
			},
			// リスト for selectItem
			getSystemcodeListLabel: function(key, value){
				if(this.list_systemcode[key]){
					const list = this.list_systemcode[key]['list'];
					for(let key in list){
						if(list[key].value == value){
							return list[key].label;
						}
					}
				}
				return '';
			},
			// リスト for selectItem
			getSystemcodeListComment: function(key, value){
				if(this.list_systemcode[key]){
					const list = this.list_systemcode[key]['list'];
					for(let key in list){
						if(list[key].value == value){
							return list[key].comment;
						}
					}
				}
				return '';
			},
			// デフォルトコード for selectItem
			getSystemcodeListDefaultCode: function(key){
				if(this.list_systemcode[key]){
					const defaultCode = this.list_systemcode[key]['defaultCode'];
					if(defaultCode == null){
						return '';
					}
					return defaultCode;
				}
				return '';
			},
			// 検索用の申請ステータス一覧を取得
			createApplyStatusListForSearch: function(settings, apply_status_cl){
				const applyStatusList = $.extend(true, [], this.getSystemcodeList(apply_status_cl));
				let list = [];
				list.push({label:' ', value: settings.search_space_app_type_id});
				console.log(settings);
				console.log(applyStatusList);
				for(let index in applyStatusList){
					if(applyStatusList[index].general1_cl == 1){
						// 汎用区分1のものを表示
						if(settings.company_apply_level < 2 && applyStatusList[index].value == settings.under_approval){
							// 企業の申請レベルが2より少ない場合は二次承認待ちステータスは表示しない
						}else{
							list.push(applyStatusList[index]);
						}
					}
				}
				return list;
			}
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/common/vuex/systemcode/read.mixin.vue